
export default {
  path: '/ssc',
  name: 'ssc',
  component: () => import('@/views/Page.vue'),
  children: [
    {
      path: 'list',
      component: () => import('@/components/ssc/List.vue'),
      meta: {
        title: 'SSC审批'
      }
    },
    {
      path: 'upcoming/details',
      component: () => import('@/components/ssc/Details.vue')
    },
    {
      path: 'complete/details',
      component: () => import('@/components/ssc/endDetails.vue')
    },
    {
      path: 'budget/details',
      component: () => import('@/components/ssc/Budget.vue'),
      meta: {
        title: '预算使用情况'
      }
    },
    {
      path: 'record/details',
      component: () => import('@/components/ssc/Record.vue'),
      meta: {
        title: '审批记录'
      }
    }
  ]
}
